module.exports = __webpack_public_path__ + "static/media/logo-ega.c3552a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Awards/logo-ega.png
// module id = 617
// module chunks = 0 1 2 3 4 34